import {
  RowMediaContainer,
  RowMediaContainerProps,
} from '@pretto/website/src/templates/blocs/rows/rowMedia/RowMediaContainer'

export const HeroMediaContainer: React.FC<RowMediaContainerProps> = props => {
  return <RowMediaContainer isHero {...props} />
}
